/* eslint-disable react-hooks/exhaustive-deps */

import { Box, ThemeProvider, createTheme } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';

import {
  getAddress,
  getAuthClientPolicies,
  getAuthDateSummary,
  getAuthorizationSummary,
  getCommunicationInfo,
  getDepartureAddress,
  getDestinationAddress,
  getEmployeeInfo,
  getFamilyMembers,
  getFamilyPets,
  getFinanceAndTax,
  getServices,
  getTeam,
  getUserSettings,
  setAuthId,
  setLoadingComplete,
  getAuthTripsByAuthId
} from '../../store/actions/authorizations.actions';

import { getTemporaryLivingAssignments } from 'modules/authorizations/store/actions/temporaryLiving.actions';

import { getVendorContacts, getVendors } from 'modules/authorizations/store/actions/dataManagement.actions';

import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import {
  fetchAuthDetails,
  fetchAuthTempLivingDetails,
  fetchEnumerations,
  fetchVendors
} from 'modules/authorizations/utils/fetchDataDetailsService';
import { showToast } from 'modules/layout/layout.actions';
import TempLiving from './tempLiving.component';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { getEmailTemplateSummaries } from 'modules/emailTemplates/store/emailTemplate.actions';
import { getClientDetails, setClientId } from 'modules/clients/clients.actions';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const TempLivingDetailsView = props => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const authId = props.match.params.id;
  const details = props.authorizationDetails ? props.authorizationDetails[authId] : null;
  const temporaryLivingAssignments = details?.authTemporaryLiving || [];
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const id = props.match.params.id;

      window.scrollTo(0, 0);
      props.setAuthId(id);
      setIsLoading(true);

      await fetchAuthDetails(details, id, props);
      await fetchVendors(props?.vendors, props);
      // await fetchVendorContacts(props?.vendorContacts, props);
      await fetchAuthTempLivingDetails(details, id, props);
      await fetchEnumerations(props);
      if (!props.templates || props.templates.isLoaded === false) {
        await props.getEmailTemplateSummaries();
      }

      setIsLoading(false);
    }

    fetchData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!isLoading && details && (
          <TempLiving
            details={details}
            clientInfo={props.clientsInfo[details.authorizationDetails.clientId]}
            authId={authId}
            history={props.history}
            location={props.location}
            temporaryLivingAssignments={temporaryLivingAssignments}
            enumerations={props.enumerations.allEnums || []}
            emailTemplates={props.templates ? props.templates.emailTemplates : []}
            allVendorOptions={props.vendors || []}
          />
        )}
        {isLoading && <FullscreenSpinner />}
      </Box>
    </ThemeProvider>
  );
};

TempLivingDetailsView.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { authorizationDetails, isLoading, vendors, vendorContacts } = state.authorizations;
  const { unmappedClients, clientsInfo } = state.clients;
  const enumerations = state.enumerations;
  const templates = state.templates;

  return {
    authorizationDetails,
    unmappedClients,
    isLoading,
    vendors,
    vendorContacts,
    enumerations,
    templates,
    clientsInfo
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getEmployeeInfo,
    getCommunicationInfo,
    getAuthClientPolicies,
    setAuthId,
    setLoadingComplete,
    getAuthDateSummary,
    getDepartureAddress,
    getDestinationAddress,
    getTeam,
    getServices,
    getUserSettings,
    getVendors,
    getVendorContacts,
    getFamilyMembers,
    getFamilyPets,
    showToast,
    getAddress,
    getFinanceAndTax,
    getTemporaryLivingAssignments,
    getAuthTripsByAuthId,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getEmailTemplateSummaries,
    getClientDetails,
    setClientId
  })
)(TempLivingDetailsView);
